import React from "react";

const SubmitButton = ({ cancel }) => {
  return (
    <button
      className={` w-full text-lg px-6 py-[10px] text-white rounded-[5px] 
        hover:bg-[#194D5F] ${
          cancel ? "bg-[#535353] hover:bg-[#888585]" : "finsire-bg-blue"
        }`}
    >
      {cancel ? "Cancel" : " Submit"}
    </button>
  );
};

export default SubmitButton;
